<template>
  <div class="projectCtrDsktp">
    <h2 class="projectTitle">Piece on Earth Pizza</h2>
    <img
      class="appPicDesktop"
      src="../assets/pieceOnEarth.jpg"
      alt="Piece on Earth Pizza landing page image"
    />
    <div class="twoLinksCtr">
      <a target="_blank" class="projectLink" href="https://www.pieceonearth.bgreenslade.com"
        >Go to site</a
      >
      <a
        target="_blank"
        class="projectLink"
        href="https://github.com/BrittanyGreenslade/PieceOnEarth"
        >View code</a
      >
    </div>
    <p class="projectDesc">
      A basic front-end, mobile-responsive mock restaurant website completed
      based on a requirements-gathering session with a "pizza shop owner". Built using
      HTML, CSS and Sass. Hosted using Google Cloud Platform and Apache.
    </p>
  </div>
</template>

<script>
export default {
  name: "piece-on-earth",
};
</script>

<style scoped>
/* .appPicDesktop {
  height: 272.86px;
} */
</style>
